module.exports = __webpack_public_path__ + "img/step_two_en.1e1401b0.png";